// src/components/TestimonialsCarousel.jsx
import React, { useState, useEffect, useRef } from 'react';
import quoteIcon from '../assets/conillas-testimonios.png'; // Ajusta la ruta según donde lo hayas guardado
import '../styles/Testimonials.css';

const testimonials = [
  {
    id: 1,
    text:
      '“Todo lo que sirvieron estuvo excelente, riquisimo y bien servido todo. Los chicos muy amables y atentos a todo. Para recomendar, excelente servicio y calidad.”',
    author: '– Veronica',
  },
  {
    id: 2,
    text:
      '“¡Un lujo todo, vas a ser nuestro servicio de catering fijo!”',
    author: '– Corporación TechSolutions',
  },
  {
    id: 3,
    text:
      '“Mi familia y yo estamos muy contentos por como salió el evento. Los invitados solo expresaron mensajes positivos y pidieron recomendacion.”',
    author: '– Familia Stoffel',
  },
  // Agrega más testimonios según necesites
];

const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);
  const AUTO_SLIDE_DELAY = 6000; // 6 segundos

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  useEffect(() => {
    // Auto‐slide (opcional). Si no quieres auto‐slide, comenta estas líneas:
    timeoutRef.current = setTimeout(() => {
      nextSlide();
    }, AUTO_SLIDE_DELAY);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [currentIndex]);

  return (
    <section id="testimonios" className="testimonials-carousel-section">
      <div className="testimonials-carousel-container">
        <h2 className="testimonials-carousel-title">Testimonios</h2>

        <div className="carousel-wrapper">
          {/* Botón previo */}
          <button
            className="carousel-button prev-button"
            onClick={() => {
              if (timeoutRef.current) clearTimeout(timeoutRef.current);
              prevSlide();
            }}
            aria-label="Testimonio anterior"
          >
            ‹
          </button>

          {/* Área visible de los slides */}
          <div className="carousel-slides">
            <div
              className="slides-track"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`,
              }}
            >
              {testimonials.map((item) => (
                <div key={item.id} className="testimonial-card">
                  {/* Icono de comillas, en la esquina superior izquierda */}
                  <img
                    src={quoteIcon}
                    alt=""
                    className="quotes-icon"
                    aria-hidden="true"
                  />

                  <p className="testimonial-text">{item.text}</p>
                  <p className="testimonial-author">{item.author}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Botón siguiente */}
          <button
            className="carousel-button next-button"
            onClick={() => {
              if (timeoutRef.current) clearTimeout(timeoutRef.current);
              nextSlide();
            }}
            aria-label="Próximo testimonio"
          >
            ›
          </button>
        </div>

        {/* Puntos de paginación */}
        <div className="carousel-dots">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              className={`dot ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => {
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                setCurrentIndex(idx);
              }}
              aria-label={`Ir al testimonio ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
